export enum InsightView {
    Agent = 'Agent',
    Campaign = 'Campaign',
    Customer = 'Customer',
    Operational = 'Operational',
}